import LBox from "@components/LBox";
import LPressable from "@components/LPressable";
import LScreen from "@components/LScreen";
import LText from "@components/LText";
import ScreenHeaderGapAndroidAndWeb from "@components/ScreenHeaderGapAndroidAndWeb";
import UserAvatar from "@components/UserAvatar";
import { useSongsCredits } from "@hooks/trpc/useSongs";
import { getActiveTab } from "@hooks/useActiveTab";
import { router, useLocalSearchParams } from "expo-router";
import { Platform } from "react-native";
import { MinimalArtist } from "@libs/types/models/client";
import { toast } from "sonner-native";

type SoundCreditsParams = {
  songId: string;
};

const Title = ({ title }: { title: string }) => {
  return (
    <LText variant="h1" mb="m1" color="creditsTitleText" textAlign="center">
      {title}
    </LText>
  );
};

const User = ({
  artist,
}: {
  artist: MinimalArtist & { profileAvailable?: boolean };
}) => {
  const handlePressArtist = () => {
    if (artist.profileAvailable === false) {
      toast.error("This artist profile is unavailable");
      return;
    }
    router.dismiss();

    router.navigate({
      pathname: `/(app)/(tabs)/${getActiveTab()}/artist/[artistId]`,
      params: {
        artistId: artist.id,
      },
    });
  };

  return (
    <LPressable
      sentryEventName={`sound_credits_${artist.id}`}
      onPress={handlePressArtist}
    >
      <LBox flexGrow={1} flexDirection="row" alignItems="center" py="s1">
        <LBox mr="s3">
          <UserAvatar
            image={artist.image}
            size={45}
            borderColor="buttonTextPrimary"
          />
        </LBox>
        <LBox width="40%">
          <LText variant="bodyL" fontWeight="bold">
            {artist.name}
          </LText>
        </LBox>
      </LBox>
    </LPressable>
  );
};

const SoundCredits = () => {
  const { songId } = useLocalSearchParams<SoundCreditsParams>();
  const songCredit = useSongsCredits([songId]).query.data;

  const artistsFiltered = {
    artists: songCredit?.artists,
  };

  return (
    <LScreen
      pt={Platform.select({ ios: "l3", android: "s4" })}
      px="l3"
      blurAmount={2}
      safeArea={Platform.OS === "android"}
    >
      <ScreenHeaderGapAndroidAndWeb />
      {Object.entries(artistsFiltered).map(([key, values]) => {
        if (!values?.length) return null;
        const title = key.replace(/([A-Z])/g, " $1");

        return (
          <LBox mb="l1" key={`${key}`}>
            <Title title={title.charAt(0).toUpperCase() + title.slice(1)} />
            <LBox>
              {values.map((artist) => (
                <User artist={artist} key={artist.id} />
              ))}
            </LBox>
          </LBox>
        );
      })}
    </LScreen>
  );
};

export default SoundCredits;
